class MFooter extends HTMLElement {
  constructor() {
    super();
    this.init();
  }

  init() {
    const mobileAccordion = this.querySelector(".m-footer--accordion");
    const mobileStickyBar = document.querySelector(".m-mobile-sticky-bar");

    if (mobileAccordion) {
      if (MinimogTheme.config.mqlMobile) {
        this.acc = new MinimogLibs.Accordion(mobileAccordion, { presetContentHeight: true, onload: true });
      }
      document.addEventListener("matchMobile", () => {
        this.acc = new MinimogLibs.Accordion(mobileAccordion, { presetContentHeight: true, onload: true });
      });
    }

    // Set mobile stickybar height (sticky ATC + page padding depend on this)
    if (mobileStickyBar) {
      const setHeight = () => {
        document.documentElement.style.setProperty(
          "--mobile-sticky-bar-height",
          `${mobileStickyBar.offsetHeight}px`
        );
      };
      setHeight();
      document.addEventListener("matchMobile", setHeight);
      document.addEventListener("unmatchMobile", setHeight);
      if (typeof ResizeObserver !== "undefined") {
        new ResizeObserver(setHeight).observe(mobileStickyBar);
      }
    }
  }
}
customElements.define("m-footer", MFooter);
